export const siteConfig = {
  siteUrl: (import.meta.env.VITE_SITE_URL || "https://moodshot.axqora.com").replace(/\/$/, ""),
  // 留空时首页按钮会退化成「即将上架」的禁用态，见 AppStoreButton。
  // 按页面语言选商店地区（中文页 /cn、英文页 /us）：不带地区码的链接在 Mac 网页版会被苹果跳到 Today 页。
  // VITE_APP_STORE_URL 设了就对所有语言生效。
  appStoreUrl: {
    en: import.meta.env.VITE_APP_STORE_URL || "https://apps.apple.com/us/app/id6809993114",
    zh: import.meta.env.VITE_APP_STORE_URL || "https://apps.apple.com/cn/app/id6809993114",
    "zh-Hant": import.meta.env.VITE_APP_STORE_URL || "https://apps.apple.com/tw/app/id6809993114"
  }
};
